<template>
  <div>
    <div style="margin-bottom: 5px">
      <el-input
          v-model="deptName"
          placeholder="请输入部门名"
          suffix-icon="el-icon-search"
          style="font-size: 18px; width: 200px"
          @keyup.enter.native="loadPost"
      ></el-input>
      <el-button
          type="primary"
          style="margin-left: 5px; font-size: 18px"
          @click="loadPost"
      >
        查询
      </el-button>
      <el-button
          type="warning"
          style="font-size: 18px"
          @click="resetParam"
      >
        重置
      </el-button>

      <el-button
          type="primary"
          style="margin-left: 5px; font-size: 18px"
          @click="add"
      >
        新增
      </el-button>
    </div>
    <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
        border
    >
      <el-table-column type="index" label="ID" width="60" />
      <el-table-column prop="deptName" label="部门名" width="250"  align="center" />
      <el-table-column prop="remark" label="备注" />
      <el-table-column
          label="操作"
          width="240"
          fixed="right"
      >
        <template slot-scope="scope">
          <el-button
              style="font-size: 18px"
              type="success"
              @click="mod(scope.row)"
          >
            编辑
          </el-button>
          <el-popconfirm
              title="确定删除吗？"
              @confirm="del(scope.row.id)"
              style="margin-left: 5px"
          >
            <el-button
                slot="reference"
                type="danger"
                v-if="user.roleId !== 1"
                style="font-size: 18px"
            >
              删除
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
    />

    <el-dialog
        title="部门信息"
        :visible.sync="centerDialogVisible"
        width="30%"
        center
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="80px">
        <el-form-item label="部门名" prop="deptName">
          <el-col :span="20">
            <el-input v-model="form.deptName"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-col :span="20">
            <el-input
                type="textarea"
                v-model="form.remark"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="centerDialogVisible = false"
            style="font-size: 18px"
        >
          取 消
        </el-button>
        <el-button type="primary" @click="save" style="font-size: 18px">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "DeptManage",
  data() {
    return {
      user: JSON.parse(sessionStorage.getItem("CurUser")),
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      deptName: "",
      centerDialogVisible: false,
      form: {
        id: "",
        deptName: "",
        remark: ""
      },
      rules: {
        deptName: [
          {
            required: true,
            message: "请输入部门名",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    resetForm() {
      this.$refs.form.resetFields();
    },
    // 删除
    del(id) {
      this.$axios
          .get(this.$httpUrl + "/dept/del?id=" + id)
          .then(res => res.data)
          .then(res => {
            if (res.code === 200) {
              this.$message({ message: "操作成功！", type: "success" });
              this.loadPost();
            } else {
              this.$message({ message: "操作失败！", type: "error" });
            }
          });
    },
    // 编辑回显
    mod(row) {
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        this.form.id = row.id;
        this.form.deptName = row.deptName;
        this.form.remark = row.remark;
      });
    },
    // 新增
    add() {
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    // 新增保存
    doSave() {
      this.$axios
          .post(this.$httpUrl + "/dept/save", this.form)
          .then(res => res.data)
          .then(res => {
            if (res.code === 200) {
              this.$message({ message: "操作成功！", type: "success" });
              this.centerDialogVisible = false;
              this.loadPost();
              this.resetForm();
            } else {
              this.$message({ message: "操作失败！", type: "error" });
            }
          });
    },
    // 修改保存
    doMod() {
      this.$axios
          .post(this.$httpUrl + "/dept/update", this.form)
          .then(res => res.data)
          .then(res => {
            if (res.code === 200) {
              this.$message({ message: "操作成功！", type: "success" });
              this.centerDialogVisible = false;
              this.loadPost();
              this.resetForm();
            } else {
              this.$message({ message: "操作失败！", type: "error" });
            }
          });
    },
    // 保存统一入口
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.id ? this.doMod() : this.doSave();
        }
      });
    },
    handleSizeChange(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.loadPost();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadPost();
    },
    resetParam() {
      this.deptName = "";
    },
    // 分页查询
    loadPost() {
      this.$axios
          .post(this.$httpUrl + "/dept/listPage", {
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            param: {
              name: this.deptName
            }
          })
          .then(res => res.data)
          .then(res => {
            if (res.code === 200) {
              this.tableData = res.data;
              this.total = res.total;
            }
          });
    }
  },
  beforeMount() {
    this.loadPost();
  }
};
</script>

<style scoped>
</style>